import {Price} from '../price';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

export type UpsellBillingCycle = 'monthly' | 'yearly';

export function findBestPrice(
  token: UpsellBillingCycle,
  prices: Price[]
): Price | undefined {
  // Try to find price matching the billing cycle and detected currency
  const detectedCurrency = getDetectedCurrency();
  
  if (token === 'monthly') {
    const match = findMonthlyPrice(prices, detectedCurrency);
    if (match) return match;
  }

  if (token === 'yearly') {
    const match = findYearlyPrice(prices, detectedCurrency);
    if (match) return match;
  }

  // Fallback to original logic if no currency-specific price found
  if (token === 'monthly') {
    const match = findMonthlyPrice(prices);
    if (match) return match;
  }

  if (token === 'yearly') {
    const match = findYearlyPrice(prices);
    if (match) return match;
  }

  return prices[0];
}

function getDetectedCurrency(): string | null {
  try {
    const data = getBootstrapData();
    return data?.detected_currency || null;
  } catch {
    return null;
  }
}

function findYearlyPrice(prices: Price[], preferredCurrency?: string | null) {
  // First try to find price with preferred currency
  if (preferredCurrency) {
    const currencyMatch = prices.find(price => {
      const matchesCurrency = price.currency?.toLowerCase() === preferredCurrency.toLowerCase();
      const matchesInterval = 
        (price.interval === 'month' && price.interval_count >= 12) ||
        (price.interval === 'year' && price.interval_count >= 1);
      return matchesCurrency && matchesInterval;
    });
    if (currencyMatch) return currencyMatch;
  }

  // Fallback to original logic
  return prices.find(price => {
    if (price.interval === 'month' && price.interval_count >= 12) {
      return price;
    }
    if (price.interval === 'year' && price.interval_count >= 1) {
      return price;
    }
  });
}

function findMonthlyPrice(prices: Price[], preferredCurrency?: string | null) {
  // First try to find price with preferred currency
  if (preferredCurrency) {
    const currencyMatch = prices.find(price => {
      const matchesCurrency = price.currency?.toLowerCase() === preferredCurrency.toLowerCase();
      const matchesInterval = 
        (price.interval === 'day' && price.interval_count >= 30) ||
        (price.interval === 'month' && price.interval_count >= 1);
      return matchesCurrency && matchesInterval;
    });
    if (currencyMatch) return currencyMatch;
  }

  // Fallback to original logic
  return prices.find(price => {
    if (price.interval === 'day' && price.interval_count >= 30) {
      return price;
    }
    if (price.interval === 'month' && price.interval_count >= 1) {
      return price;
    }
  });
}
